import Graph from '../lib/node-dijkstra/libs/Graph'
import { standardize } from '../utils/String'
import floors from './floors'
import Locale from './localization'
import * as objectTypes from '../constants/objectTypes'

const elevatorCoords = {
    '96': {
        x: 86,
        y: 328
    },
    '33': {
        x: 302,
        y: 235
    },
    '34': {
        x: 146,
        y: 327
    },
    '79': {
        x: 87,
        y: 328
    },
    '227': {
        x: 104,
        y: 390
    },
    '244': {
        x: 183,
        y: 279
    }
}

const poiCooors = {
    '35': {
        x: 427,
        y: 331
    },
    '36': {
        x: 461,
        y: 331
    },
    '98': {
        x: 105,
        y: 225
    },
    '245': {
        x: 343,
        y: 275
    },
    '263': {
        x: 427,
        y: 346
    },
    '264': {
        x: 461,
        y: 346
    },
    '266': {
        x: 476,
        y: 331
    },
    '267': {
        x: 343,
        y: 290
    },
    '268': {
        x: 343,
        y: 305
    },
    '277': {
        x: 476,
        y: 346
    }
}

const elevators = PICTOGRAMS
    .filter(item => item.content === 'picto-elevator' || item.content === 'picto-parking-elevator')
    .map(item => {
        const { id, floor } = item

        const coords = elevatorCoords[id] ? {...elevatorCoords[id]} : {x: 0, y: 0}

        return {
            id,
            floor,
            name: Locale.entities.elevator,
            type: objectTypes.ELEVATOR,
            popularity: 0,
            nodes: {},
            ...coords
        }
    });

SHOPS.push(...elevators)

const pointsOfInterest = PICTOGRAMS
    .filter(item => item.content === 'picto-handicap' || item.content === 'picto-baby' || item.content === 'picto-toilets' || item.content === 'picto-baby-bottle' || item.content === 'picto-info')
    .map(item => {
        const { id, floor } = item

        const coords = poiCooors[id] ? { ...poiCooors[id] } : { x: 0, y: 0 }

        const type = item.content.replace('picto-', '')

        return {
            id,
            floor,
            name: Locale.entities[item.content.replace('picto-', '')],
            type: type,
            popularity: 0,
            nodes: {},
            ...coords
        }
    })

SHOPS.push(...pointsOfInterest)

const SHOPS_BY_ID = SHOPS.reduce((acc, item) => {
    acc[item.id] = item
    return acc
}, {})

const NODES = OBJECTS.nodes

const data = {
    nodes: Object.keys(NODES).map(key => {
        const node = NODES[key];
        node.name = node.shopId || '  ';

        if (node.shopId && node.shopId in SHOPS_BY_ID) {
            const shop = SHOPS_BY_ID[node.shopId];

            if (!('nodes' in shop)) {
                shop.nodes = {}
            }

            node.nodes[node.shopId] = 1;
            shop.nodes[node.id] = 1;
        }

        return node
    }).concat(Object.keys(SHOPS_BY_ID).map(key => SHOPS_BY_ID[key])),
    groups: GROUPS
}

// GROUPS
const groups = data.groups.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
}, {});

Object.keys(groups)
    .sort((a, b) => groups[a].name.localeCompare(groups[b].name))
    .forEach((id, index) => groups[id].seq = index)

// NODES
const nodes = data.nodes.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
}, {});

Object.keys(nodes)
    .filter(id => nodes[id].type !== 'node')
    .sort((a, b) => nodes[a].name.localeCompare(nodes[b].name))
    .forEach((id, index) => {
        const item = nodes[id];
        item.seq = index;
        item.note = item.type !== 'entrance' && item.floor != null ? Locale.floors[item.floor] : '';
        item.children = [];

        if (item.groupId) {
            item.groupId.forEach(groupId => {
                const group = groups[groupId];

                if (group) {
                    if (!('popularity' in group)) {
                        group.popularity = 0;
                    }

                    group.popularity += item.popularity || 0;

                    if (!('children' in group)) {
                        group.children = [];
                    }

                    group.children.push(id);
                }
            });
        }
    });

// search cleanup
Object.keys(nodes)
    .forEach(key => nodes[key].search = standardize(nodes[key].name || '').toLowerCase());

// escalators
// 2. patro
nodes[25].nodes[70] = 50; // predek, dolu
nodes[28].nodes[72] = 50; // zadek, dolu

// 1. patro
nodes[70].nodes[25] = 50; // predek, nahoru
nodes[71].nodes[81] = 50; // predek, dolu
nodes[72].nodes[28] = 50; // zadek, nahoru
nodes[73].nodes[84] = 50; // zadek, dolu

// 0. patro
nodes[81].nodes[71] = 50; // predek nahoru
nodes[80].nodes[216] = 50; // predek dolu
nodes[82].nodes[27] = 50; // predek do 2. patra
nodes[84].nodes[73] = 50; // zadek, nahoru
nodes[83].nodes[218] = 50; // zadek, dolu

// -1. patro
// nodes[216].nodes[80] = 50; // predek nahoru
nodes[218].nodes[83] = 50; // zadek, nahoru
nodes[217].nodes[231] = 50; // zadek, dolu
// nodes['s13'].nodes['s14'] = 50; // schody dolu

// -2. patro
nodes[231].nodes[217] = 50; // zadek, nahoru
nodes[230].nodes['230b'] = 50; // zadek do garazi
// nodes['s14'].nodes['s13'] = 50; // schody nahoru

// -3. patro - garaze
nodes['230b'].nodes[230] = 50; // nahoru
nodes['e3'].nodes['230b'] = 50; // napojeni eskalatoru
nodes['230b'].nodes['e3'] = 50; // napojeni eskalatoru

// elevators
nodes['e3'].nodes['ge1'] = 50; // vytah z garazi
nodes['ge1'].nodes['e3'] = 50; // vytah z garazi

nodes['e3'].nodes['ge2'] = 50; // vytah z garazi do 2. patra
nodes['ge2'].nodes['e3'] = 50; // vytah z garazi do 2. patra

nodes['ge1'].nodes[244] = 50; // vytah z garazi do -2. patra
nodes['ge1'].nodes[227] = 50; // vytah z garazi do -1. patra
nodes['ge1'].nodes[96] = 50; // vytah z garazi do 0. patra
nodes['ge1'].nodes[79] = 50; // vytah z garazi do 1. patra
nodes['ge1'].nodes[34] = 50; // vytah z garazi do 2. patra

nodes['ge2'].nodes[33] = 50; // vytah z garazi do 2. patra
nodes[33].nodes['ge2'] = 50; // vytah 2. patra do garazi

nodes[244].nodes['ge1'] = 50; // vytah z -2. patra do garazi
nodes[244].nodes[227] = 50; // vytah z -2. patra do -1. patra
nodes[244].nodes[96] = 50; // vytah z -2. patra do 0. patra
nodes[244].nodes[79] = 50; // vytah z -2. patra do 1. patra
nodes[244].nodes[34] = 50; // vytah z -2. patra do 2. patra

nodes[227].nodes['ge1'] = 50; // vytah z -1. patra do garazi
nodes[227].nodes[244] = 50; // vytah z -1. patra do -2. patra
nodes[227].nodes[96] = 50; // vytah z -1. patra do 0. patra
nodes[227].nodes[79] = 50; // vytah z -1. patra do 1. patra
nodes[227].nodes[34] = 50; // vytah z -1. patra do 2. patra

nodes[96].nodes['ge1'] = 50; // vytah z 0. patra do garazi
nodes[96].nodes[244] = 50; // vytah z 0. patra do -2. patra
nodes[96].nodes[227] = 50; // vytah z 0. patra do -1. patra
nodes[96].nodes[79] = 50; // vytah z 0. patra do 1. patra
nodes[96].nodes[34] = 50; // vytah z 0. patra do 2. patra

nodes[79].nodes['ge1'] = 50; // vytah z 1. patra do garazi
nodes[79].nodes[244] = 50; // vytah z 1. patra do -2. patra
nodes[79].nodes[227] = 50; // vytah z 1. patra do -1. patra
nodes[79].nodes[96] = 50; // vytah z 1. patra do 0. patra
nodes[79].nodes[34] = 50; // vytah z 1. patra do 2. patra

nodes[34].nodes['ge1'] = 50; // vytah z 2. patra do garazi
nodes[34].nodes[244] = 50; // vytah z 2. patra do -2. patra
nodes[34].nodes[227] = 50; // vytah z 2. patra do -1. patra
nodes[34].nodes[96] = 50; // vytah z 2. patra do 0. patra
nodes[34].nodes[79] = 50; // vytah z 2. patra do 1. patra


const cache = Object.keys(nodes)
    .reduce((acc, id) => {
        const children = nodes[id].nodes || {};
        if (!(id in acc)) {
            acc[id] = {};
        }

        acc[id] = {
            ...acc[id],
            ...children
        }

        return acc;
    }, {});

const graph = new Graph();

Object.keys(cache).forEach(key => {
    graph.addNode(key, cache[key]);
});

// EDGES
const edges = {};
let edgeId = 1;

Object.keys(cache).forEach(from => {
    Object.keys(cache[from]).forEach(to => {
        const id = edgeId++;
        const value = cache[from][to];
        edges[id] = {
            id,
            from,
            to,
            value
        }
    });
});

const polygons = Object.keys(OBJECTS.polygons)
    .reduce((acc, key) => {
        const polygon = OBJECTS.polygons[key];
        floors[polygon.floor].polygons.push(polygon.id)
        acc[polygon.id] = {
            path: polygon.path,
            centerX: polygon.centerX,
            centerY: polygon.centerY,
            width: polygon.width,
            height: polygon.height,
            image: polygon.id in SHOPS_BY_ID ? SHOPS_BY_ID[polygon.id].image : null
        }

        return acc;
    }, {})

export const entities = {
    nodes,
    edges,
    groups,
    floors,
    polygons
}

export const route = graph;


// WEBPACK FOOTER //
// ./data/data.js